import ScrollToTop from '../../../../components/ScrollToTop'
import Bar from '../../../../components/Bar/Bar'
import MobileNavigation from '../../../../components/MobileNavigation'
import Close from '../../../../components/Close/Close'
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { motion } from "framer-motion"

export default function IPP(){
  return(
    <HelmetProvider>
    <motion.div exit={{ opacity:0 }} animate={{ opacity:1 }} initial={{ opacity:0 }}
    transition={{ ease: [0,.68,0,1.01],duration: 1.5 }}> 
      <Helmet>
       <meta charSet="utf-8" />
       <title>Lucas Zorzetto ― IPP</title>
      </Helmet>
          <Bar/>
          <MobileNavigation/>
          <ScrollToTop/>
          <Close/>
          <div className='project-content'>
          <div className='container-project'>
          <div className="video-embed-sqr">
          <iframe src="https://player.vimeo.com/video/1133347599?h=40d3630c02" width="100%" height="960" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen></iframe>
          </div>
          <hr className="divider-small"></hr>
          <h1>IPP 001</h1>
          <a8>2025</a8>
          <hr className="divider-small"></hr>
          <p id="description">This is a project from a series of short loo ps I started in July 2024, which was put aside months later. Check out the full project on&nbsp;<a id='link' href="https://www.behance.net/gallery/237860597/IPP-001" target="_blank">Behance</a>!</p>
          <div className="role">
          <hr className="divider-small"></hr>
          <h1>Role</h1>
          <a1>Animation, Design and Sound design</a1>
          </div>
          </div>
      </div>
    </motion.div>
    </HelmetProvider>
)
}